import React from 'react';
import { SheetLayout } from '@/ui/layout/SheetLayout';
import { DashboardHeader } from './DashboardHeader';
import DashboardSidebar from '@/components/DashboardSidebar';

interface DashboardLayoutProps {
  children: React.ReactNode;
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children, activeTab, onTabChange }) => {
  return (
    <SheetLayout>
      <DashboardHeader />

      {/* Main Layout Grid: Sidebar + Content */}
      <div className="flex flex-col md:flex-row min-h-[calc(100vh-80px)]">
         {/* Sidebar Area */}
         <div className="md:w-64 border-r-2 border-neutral-950 dark:border-neutral-100 bg-neutral-50 dark:bg-neutral-900/10 flex-shrink-0">
             <div className="sticky top-[80px]">
                <DashboardSidebar onSelect={onTabChange} selectedKey={activeTab} className="border-none w-full" />
             </div>
         </div>

         {/* Main Content Area */}
         <main className="flex-1 bg-background">
             {children}
         </main>
      </div>
    </SheetLayout>
  );
};
